module.exports = __webpack_public_path__ + "static/media/plusCircle.73090a51.svg";